import styled from "styled-components";

export const IssuesFixScreenWrapper = styled.div`
.FixReportIssuesParent{
    padding: 2%;
    margin-top:4%;
    max-width: 80%;
    border: 1px solid #d5d5d5;
    border-radius: 10px;
    padding-top: 4%;
    min-height: 17rem;
}
.submitImagesTextParent{
    margin-bottom:3%;
}
.submitImagesText{
    font-weight: 500;
    font-size: 18px;
    margin-top: 2% !important;
}
.submitExactform{
    margin: 4% 0%;
}
.showFormatted{
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 5px;
    padding: 2% 0;
}

.showFormattedQtex{
    text-align: center;
    background: #213861;
    color: white;
    padding: 1% 2%;
    border-radius: 15px;
    font-size: 12px;
}
.buttonsSections{
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    padding:0 5%;
    margin-top:10%;
}

.saveAndTestButton{
    text-align: center;
}
.saveAndTestButton button{
    border: none;
    background: #213861;
    width: 55%;
    padding: 2%;
    border-radius: 5px;
    color: white;
    cursor: pointer;
}

.block{
    cursor: not-allowed;
    pointer-events: none;
    
}
.block button{
    opacity: 0.8;
    cursor: not-allowed;
    pointer-events: none;
}
.block button div{
    display: flex;
    align-items: center;
    justify-content: center;
    gap:5px;
}

.submitButton{
    width: 150px;
    display: flex;
    font-size: 11px;
    justify-content: center;
    align-items: center;
    height: 30px;
    background: #0074ff;
    color: white;
    border-radius: 5px;
    cursor: pointer;
}

.ShowImagesParent{
    width: 70%;
    margin: 0 auto 2%;
}
.showImages{
    border:none;
    background: #0074ff;
    color: white;
    border-radius: 5px;
    padding: 2% 2%;
    width: 100%;
}
.label{
    font-weight: 600;
    font-size: 15px;
    margin-bottom: 1% !important;
}
.mcqJson{
    margin: 4% 0%;
}

}
`;